import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const dashboardViewEmbedRoute: InvariantJiraRoute = {
	name: 'dashboard-view-embed',
	path: '/jira/dashboards/:dashboardId(\\d+)/embed',
	query: [],
	exact: true,
};
